import React, {useState, useEffect, useMemo} from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import '../styles/global.css'; // Seu CSS global
import axios from 'axios';
import { CircularProgress } from '@mui/material'
import { SwapVert, ThumbUpAlt, ThumbDownOffAlt, Visibility, VisibilityOff, Ballot, BallotOutlined } from '@mui/icons-material';
import MenuAssociados from '../components/MenuAssociados';
import { set } from 'draft-js/lib/DefaultDraftBlockRenderMap';


function Assembleias() {
    const [assembleias, setAssembleias] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [totalAssembleias, setTotalAssembleias] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const loggedIn = sessionStorage.getItem('loggedIn');
    const [selectStatusRegistroAssembleia, setSelectStatusRegistroAssembleia] = useState('');

    function handleNovoCadastro() {
    // Lógica para lidar com o novo cadastro de assembleia
    }

    function pesquisar(valor) {
        setSearchTerm(valor);
    }

    function handlePesquisaStatusChange(event) {
        setSelectStatusRegistroAssembleia(event.target.value);
    }

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens

    //ordenação do resultado pessoas
    
    const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = useState(config);

    const sortedItems = useMemo(() => {
        let sortableItems = [...items];
        if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
        }
        return sortableItems;
    }, [items, sortConfig]);

    const requestSort = key => {
        let direction = 'ascending';
        if (sortConfig && 
        sortConfig.key === key && 
        sortConfig.direction === 'ascending'
        ) {
        direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    return { items: sortedItems, requestSort, sortConfig };
    };
    const { items, requestSort, sortConfig } = useSortableData(assembleias);

    const getClassNamesFor = name => {
    if (!sortConfig) {
        return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined
    }

    //carregar assembleias
    useEffect(() => {
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        axios
        .get(process.env.REACT_APP_API_URL + '/routes.php?metodo=obterAssembleias', {
            headers: {
                "X-Access-Token" : tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(response => {
            setAssembleias(response.data);
        })
        .catch(error => {
            console.error('Erro ao carregar assembleias:', error);
        });
    }, []);

    // useEffect para ordenar assembleias por IdAssembleia desc
    useEffect(() => {
        const sortedAssembleias = [...assembleias].sort((a, b) => b.IdAssembleia - a.IdAssembleia);
        setAssembleias(sortedAssembleias);
    }, []);

    //salvar log de navegação
    useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
        IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
        logTipo: "Navegação",
        logModulo: "Página de Assembleias",
        logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
        logCriadoEm: new Date().toISOString(),
        logCodigoGUID: crypto.randomUUID()
    };
    axios                    
    .post(process.env.REACT_APP_API_URL 
        + '/routes.php?metodo=novoLog', 
        log, {
            headers: {
                "X-Access-Token" : tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        }
    )
    .then(response => {
        //console.log(response.data[0].mensagem);
    })
    .catch(error => {
        console.error('Erro ao enviar log:', error);
    });
    }, []);

    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
    }, []);

    function handleEditAssembleia(assembleia) {
        if (parseInt(sessionStorage.pesAdmin) === 1) {
            sessionStorage.selectAssembleia = assembleia.IdAssembleia;
            navigate(`/Assembleia/${assembleia.IdAssembleia}`);
        }
    }

    function handleEditVotacao(assembleia) {
        if (parseInt(sessionStorage.pesAdmin) === 1) {
            sessionStorage.selectAssembleia = assembleia.IdAssembleia;
            if (assembleia.IdVotacao > 0) {
                navigate(`/Votacao/${assembleia.IdVotacao}`);
            } else {
                const criarNovaVotacao = window.confirm('Não há votação disponível para esta assembleia.\nDeseja criar uma nova votação?');
                if (!criarNovaVotacao) {
                    return;
                }
                navigate(`/Votacao/0/${assembleia.IdAssembleia}`);
            }
        } else if (parseInt(assembleia.IdVotacao) > 0) {
            navigate(`/Resultado/${assembleia.IdVotacao}`);
        } else if (parseInt(assembleia.IdVotacao) === 0 && parseInt(sessionStorage.pesAdmin) === 0) {
            window.alert('Não há votação disponível para esta assembleia.');
        }
    }

    //vai para linha de foco após edição
    useEffect(() => {
    
    const itemClicadoId = sessionStorage.getItem('selectAssembleia');

    if (itemClicadoId) {
        const elementoLinha = document.getElementById(`linha-${itemClicadoId}`);
        
        if (elementoLinha) {
        // Rola até a linha clicada de forma suave
        setTimeout(() => {
            elementoLinha.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // Destaque visual temporário opcional (ex: piscar a linha)
            elementoLinha.style.backgroundColor = '#fff9c4'; 
            setTimeout(() => elementoLinha.style.backgroundColor = '', 3000);
        }, 100); // Um pequeno delay garante que o HTML já renderizou

        // 2. Limpa o ID para não rolar de novo se o usuário atualizar a página (F5)
        sessionStorage.removeItem('selectAssembleia');
        }
    }
    }, [assembleias]);

    return (
        <div style={{ paddingBottom: '80px'}}>
            <main style={{paddingBottom: '80px'}}>
                <div>
                    <div>
                        <MenuAssociados />
                    </div>
                    <div className="headerMain">
                        <label className="labelTitulo">Assembleias</label>
                        <h5>Acompanhe e fique por dentro das decisões importantes.</h5>
                        <span style={{ color: 'orange', fontWeight: 'bold', fontSize: '14px', marginTop: '20px' }}>EM DESENVOLVIMENTO, DADOS MERAMENTE ILUSTRATIVOS</span>
                        {/* <hr style={{ marginTop: '20px', marginBottom: '20px', width: '100%' }} /> */}
                    </div>
                    <div className="containerBarraPesquisa">
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                            <Link to="/Assembleia/0">
                                <button className="buttonModalPadrao" >
                                    NOVA ASSEMBLEIA
                                </button>
                            </Link> ) : ('')}
                        <input className="inputBarraPesquisa"
                            placeholder="PESQUISAR"
                            type="text"
                            id="inputPesquisa"
                            name="inputPesquisa"
                            onChange={event => {
                                pesquisar(event.target.value);
                            }}
                        />

                        <select className="selectStatusPesquisa"
                            name="selectStatusRegistroAssociado"
                            selected={sessionStorage.selectStatusRegistroAssembleia !== undefined ? sessionStorage.selectStatusRegistroAssembleia : '99'}
                            onChange={event => {
                                handlePesquisaStatusChange(event)
                            }}
                            >
                            <option value={''} selected={sessionStorage.selectStatusRegistroAssembleia === ''} >TODOS</option>
                            <option value={'CONVOCADO'} selected={sessionStorage.selectStatusRegistroAssembleia === 'CONVOCADO'} >CONVOCADO</option>
                            <option value={'ANDAMENTO'} selected={sessionStorage.selectStatusRegistroAssembleia === 'ANDAMENTO'} >ANDAMENTO</option>
                            <option value={'CANCELADO'} selected={sessionStorage.selectStatusRegistroAssembleia === 'CANCELADO'} >CANCELADO</option>
                            <option value={'ENCERRADO'} selected={sessionStorage.selectStatusRegistroAssembleia === 'ENCERRADO'} >ENCERRADO</option>
                        </select>
                    </div>
                </div>

                <div className="tabelaPadrao">
                    {windowWidth < 769 ? (
                        // Renderização para telas menores que 769px
                        isLoading ? <tr><td colSpan="6" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                            items
                            .filter(assembleia => {
                                if (searchTerm === '') {
                                    if (selectStatusRegistroAssembleia === '') {
                                        return assembleia;
                                    } else if (selectStatusRegistroAssembleia === 'CONVOCADO') {
                                        return assembleia.assPosicao === 'CONVOCADO';
                                    } else if (selectStatusRegistroAssembleia === 'ANDAMENTO') {
                                        return assembleia.assPosicao === 'ANDAMENTO';
                                    } else if (selectStatusRegistroAssembleia === 'CANCELADO') {
                                        return assembleia.assPosicao === 'CANCELADO';
                                    } else if (selectStatusRegistroAssembleia === 'ENCERRADO') {
                                        return assembleia.assPosicao === 'ENCERRADO';
                                    } else {
                                        return assembleia;
                                    }
                                } else if (
                                    assembleia.assDescricao.toLowerCase().includes(searchTerm.toLowerCase())
                                    || assembleia.assPosicao.toLowerCase().includes(searchTerm.toLowerCase())
                                    || assembleia.assTipo.toLowerCase().includes(searchTerm.toLowerCase())
                                    || assembleia.assFormato.toLowerCase().includes(searchTerm.toLowerCase())
                                )
                                 {
                                    if (selectStatusRegistroAssembleia === '') {
                                        return assembleia; 
                                    } else if (selectStatusRegistroAssembleia === 'CONVOCADO') {
                                        return assembleia.assPosicao === 'CONVOCADO';
                                    } else if (selectStatusRegistroAssembleia === 'ANDAMENTO') {
                                        return assembleia.assPosicao === 'ANDAMENTO';
                                    } else if (selectStatusRegistroAssembleia === 'CANCELADO') {
                                        return assembleia.assPosicao === 'CANCELADO';
                                    } else if (selectStatusRegistroAssembleia === 'ENCERRADO') {
                                        return assembleia.assPosicao === 'ENCERRADO';
                                    } else {
                                        return assembleia;
                                    }
                                }
                            })
                            .map(assembleia => (
                                <div style={{borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}>
                                    <div
                                        id={`linha-${assembleia.IdAssembleia}`}
                                        key={assembleia.IdAssembleia}
                                        className="p2" style={{ cursor: 'pointer' }} >
                                        <div onClick={parseInt(sessionStorage.pesAdmin) === 1 ? () => handleEditAssembleia(assembleia) : 
                                            (e) => {
                                                e.stopPropagation();
                                                const element = document.getElementById(`assembleia-ata-${assembleia.IdAssembleia}`);
                                                if (element.style.display === 'none' || !element.style.display) {
                                                    element.style.display = 'block';
                                                } else {
                                                    element.style.display = 'none';
                                                }
                                            }}>
                                            <p style={{ color: '#000' }}><b>DESCRIÇÃO: </b>{assembleia.IdAssembleia} - {assembleia.assDescricao}</p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>DATA: </b> {new Date(assembleia.assConvocacao).toLocaleDateString('pt-BR', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric'
                                        })}</p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>TIPO: </b> {assembleia.assTipo}</p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>POSIÇÃO: </b> {assembleia.assPosicao}</p>
                                        </div>
                                        <div>
                                            <p style={{ color: '#000', marginTop: '10px' }} onClick={() => handleEditVotacao(assembleia)}>{assembleia.IdVotacao > 0 ? <Ballot /> : <BallotOutlined />}</p>
                                        </div>
                                        <div>    
                                            <p style={{ color: '#000', marginTop: '10px',cursor: 'pointer' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    const element = document.getElementById(`assembleia-ata-${assembleia.IdAssembleia}`);
                                                    if (element.style.display === 'none' || !element.style.display) {
                                                        element.style.display = 'block';
                                                    } else {
                                                        element.style.display = 'none';
                                                    }
                                                }}>
                                                <label ><b>ATA: </b> <Visibility style={{ cursor: 'pointer', marginBottom: '-5px' }}  /><VisibilityOff style={{ cursor: 'pointer', marginBottom: '-5px' }} /></label>
                                                <div id={`assembleia-ata-${assembleia.IdAssembleia}`} style={{ display: 'none', marginTop: '10px' }}>
                                                    {assembleia.assAta}
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))
                    ) : (
                        // Renderização para telas maiores ou iguais a 769px
                        <table className="tabelaDados">
                            <thead>
                                <tr style={{ cursor: 'pointer' }}>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('IdAssembleia')} className={getClassNamesFor('IdAssembleia')}>Número</th>
                                    <th>Votação</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('assConvocacao')} className={getClassNamesFor('assConvocacao')}>Data</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('assDescricao')} className={getClassNamesFor('assDescricao')}>Título</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('assTipo')} className={getClassNamesFor('assTipo')}>Tipo</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('assPosicao')} className={getClassNamesFor('assPosicao')}>Posição</th>
                                    <th style={{ textAlign: "center" }} >ATA</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                isLoading ? <tr><td colSpan="6" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                                items
                                .filter(assembleia => {
                                if (searchTerm === '') {
                                    if (selectStatusRegistroAssembleia === '') {
                                        return assembleia;
                                    } else if (selectStatusRegistroAssembleia === 'CONVOCADO') {
                                        return assembleia.assPosicao === 'CONVOCADO';
                                    } else if (selectStatusRegistroAssembleia === 'ANDAMENTO') {
                                        return assembleia.assPosicao === 'ANDAMENTO';
                                    } else if (selectStatusRegistroAssembleia === 'CANCELADO') {
                                        return assembleia.assPosicao === 'CANCELADO';
                                    } else if (selectStatusRegistroAssembleia === 'ENCERRADO') {
                                        return assembleia.assPosicao === 'ENCERRADO';
                                    } else {
                                        return assembleia;
                                    }
                                } else if (
                                    assembleia.assDescricao.toLowerCase().includes(searchTerm.toLowerCase())
                                    || assembleia.assPosicao.toLowerCase().includes(searchTerm.toLowerCase())
                                    || assembleia.assTipo.toLowerCase().includes(searchTerm.toLowerCase())
                                    || assembleia.assFormato.toLowerCase().includes(searchTerm.toLowerCase())
                                ) {
                                    if (selectStatusRegistroAssembleia === '') {
                                        return assembleia; 
                                    } else if (selectStatusRegistroAssembleia === 'CONVOCADO') {
                                        return assembleia.assPosicao === 'CONVOCADO';
                                    } else if (selectStatusRegistroAssembleia === 'ANDAMENTO') {
                                        return assembleia.assPosicao === 'ANDAMENTO';
                                    } else if (selectStatusRegistroAssembleia === 'CANCELADO') {
                                        return assembleia.assPosicao === 'CANCELADO';
                                    } else if (selectStatusRegistroAssembleia === 'ENCERRADO') {
                                        return assembleia.assPosicao === 'ENCERRADO';
                                    } else {
                                        return assembleia;
                                    }
                                }
                                })
                                .map((assembleia) => (
                                    <tr style={{ cursor: 'pointer' }} id={`linha-${assembleia.IdAssembleia}`} key={assembleia.IdAssembleia}
                                        
                                    >
                                        <td onClick={() => handleEditAssembleia(assembleia)}className="text-align-center">{assembleia.IdAssembleia}</td>
                                        <td onClick={() => handleEditVotacao(assembleia)}>{assembleia.IdVotacao > 0 ? <Ballot /> : <BallotOutlined />}</td>
                                        <td onClick={() => handleEditAssembleia(assembleia)} >{new Date(assembleia.assConvocacao).toLocaleDateString('pt-BR', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric'
                                        })}</td>
                                        <td onClick={() => handleEditAssembleia(assembleia)}>{assembleia.assDescricao}</td>
                                        <td onClick={() => handleEditAssembleia(assembleia)}>{assembleia.assTipo}</td>
                                        <td onClick={() => handleEditAssembleia(assembleia)}>{assembleia.assPosicao}</td>
                                        {/* a informação assAta é muito grande, preciso de um botao que ao clicar seja exibido o texto inteiro e clicado novamente oculte */}
                                        <td>
                                            <label style={{ cursor: 'pointer' }} onClick={(e) => {
                                                e.stopPropagation();
                                                const element = document.getElementById(`assembleia-ata-${assembleia.IdAssembleia}`);
                                                if (element.style.display === 'none' || !element.style.display) {
                                                    element.style.display = 'block';
                                                } else {
                                                    element.style.display = 'none';
                                                }
                                            }}><Visibility /><VisibilityOff /></label>
                                            <div id={`assembleia-ata-${assembleia.IdAssembleia}`} style={{ display: 'none', marginTop: '10px'  }}>
                                                {assembleia.assAta}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

            </main>
        </div>
    );
}


/*
onClick={parseInt(sessionStorage.pesAdmin) === 1 ? () => handleEditAssembleia(assembleia) : 
(e) => {
    e.stopPropagation();
    const element = document.getElementById(`assembleia-ata-${assembleia.IdAssembleia}`);
    if (element.style.display === 'none' || !element.style.display) {
        element.style.display = 'block';
    } else {
        element.style.display = 'none';
    }
}}

onClick={parseInt(sessionStorage.pesAdmin) === 1 ? () => handleEditAssembleia(assembleia) : 
                                            (e) => {
                                                e.stopPropagation();
                                                const element = document.getElementById(`assembleia-ata-${assembleia.IdAssembleia}`);
                                                if (element.style.display === 'none' || !element.style.display) {
                                                    element.style.display = 'block';
                                                } else {
                                                    element.style.display = 'none';
                                                }
                                            }}
*?*/


export default Assembleias;